import React from 'react';
import update from 'immutability-helper';
import * as yup from 'yup';
import {t} from 'ttag';
import {Formik, Form} from 'formik';

import CallNotifications from './call-notifications/call-notifications.jsx';
import FirstMessage from './first-message/first-message.jsx';
import Group from './group/group.jsx';
import LineId from './line-id/line-id.jsx';
import ShowChatInTimeline from './show-chat-in-timeline/show-chat-in-timeline.jsx';
import SyncInMsgActions from './sync-in-msg-actions/sync-in-msg-actions.jsx';

import Wrapper from '../../../../../wrapper/wrapper.jsx';
import Line from '../../../../../line/line.jsx';
import Button, {SaveButton} from '../../../../../button/button';
import Preloader from '../../../../../preloader/preloader.jsx';
import EmptyBox from '../../../../../empty-box/empty-box.jsx';

import {useAppContext} from '../../../../../../app-context.js';
import {useConnectionListContext} from '../../../../connection-list-context.js';
import {useConnectionContext} from '../../../connection-context.js';
import {useSettingsContext} from '../../settings-context.js';
import {useRequest} from '../../../../../../common/hooks';
import {updateConnectionConfigReq} from '../../../../../../common/api/bitrix24.js';
import {trimValues} from '../../../../../../common/actions.js';
import IsLeadscanner from './is-leadscanner/is-leadscanner.jsx';
import {updateConnectionReq} from 'common/api/api.js';
import IsSmsProviderEnabled from './is-sms-provider-enabled/is-sms-provider-enabled.jsx';

const Bitrix24 = () => {
  const {setNotificationList, lang, user} = useAppContext();
  const {client, setSettingsId, setConnectionList} = useConnectionListContext();
  const {connection} = useConnectionContext();
  const {connectionConfig, updateConnectionConfig} = useSettingsContext();

  const {crmRequest, request} = useRequest();

  const handleSubmit = async values => {
    const is_leadscanner = values.is_leadscanner;

    const trimmedValues = trimValues(values);
    delete trimmedValues.is_leadscanner;

    const [res, instance] = await Promise.all([
      crmRequest({
        crm: client.crm,
        ...updateConnectionConfigReq({
          domain: client.domain,
          chat_id: connection.id,
          data: trimmedValues
        })
      }),
      connection.version == 'telegram' && lang == 'ru'
        ? request(
            updateConnectionReq({
              chat_key: connection.chat_key,
              data: {is_leadscanner}
            })
          )
        : undefined
    ]);

    if (Object.keys(res).length > 3) {
      setNotificationList(prevValue =>
        update(prevValue, {
          $push: [
            {
              title: connection.label || `${t`Connection`} ${connection.id}`,
              text: t`The settings have been successfully saved.`
            }
          ]
        })
      );

      updateConnectionConfig({...connectionConfig, ...res});
      setSettingsId(-1);
    }

    if (instance) {
      setConnectionList(prevValue => {
        const index = prevValue.findIndex(item => item.id == connection.id);
        if (index == undefined || undefined < 0) return prevValue;

        return update(prevValue, {
          [index]: {is_leadscanner: {$set: instance.is_leadscanner}}
        });
      });
    }

    return true;
  };

  const initialValues = connectionConfig
    ? {
        call_notifications: connectionConfig.call_notifications ?? true,
        first_message: connectionConfig.first_message || false,
        group: connectionConfig.group || false,
        line_id: connectionConfig.line_id || '',
        show_chat_in_timeline: connectionConfig.show_chat_in_timeline || false,
        is_leadscanner: connection.is_leadscanner,
        sync_in_msg_actions: connectionConfig.sync_in_msg_actions || false,
        is_sms_provider_enabled:
          connectionConfig.is_sms_provider_enabled || false
      }
    : {};

  const validationSchema = yup.object().shape({
    first_message: yup.bool(),
    group: yup.bool(),
    line_id: yup.string()
  });

  return (
    <>
      {connectionConfig ? (
        Object.keys(connectionConfig).length ? (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form>
              <Wrapper gap={16} isColumn>
                <LineId />

                {(connection.version == 'telegram' ||
                  connection.version == 'whatcrm') && (
                  <Wrapper isColumn>
                    <FirstMessage />

                    {connection.version == 'telegram' &&
                      process.env.REACT_APP_ENV != 'rocket' && (
                        <IsLeadscanner />
                      )}

                    <Group />
                    <ShowChatInTimeline />
                    <CallNotifications />
                    {user.crm == 'B24' && <SyncInMsgActions />}

                    {(user.crm == 'B24' || user.crm == 'TELPHGRAM') && (
                      <IsSmsProviderEnabled />
                    )}
                  </Wrapper>
                )}
              </Wrapper>

              <Line />

              <Wrapper>
                <SaveButton>{t`Save`}</SaveButton>

                <Button color="white" onClick={() => setSettingsId(-1)}>
                  {t`Cancel`}
                </Button>
              </Wrapper>
            </Form>
          </Formik>
        ) : (
          <EmptyBox />
        )
      ) : (
        <Preloader isMin />
      )}
    </>
  );
};

export default Bitrix24;
